import {
LuBriefcase,
LuMap,
LuTarget,
LuTrendingUp,
LuUsers,
LuDatabase,
LuShieldCheck,
LuMessageSquare,
LuRefreshCw
} from "react-icons/lu"
import { useState,useEffect } from "react"
import { useLocation } from "react-router-dom"
import "./Services.css"
import OurConnections from "./OurConnections"

function Services(){

const [loaded,setLoaded]=useState(false)
const location = useLocation()

useEffect(()=>{

// Ensure page always starts from top
window.scrollTo({ top: 0, left: 0, behavior: 'instant' })

setLoaded(false)

const timer=setTimeout(()=>{
setLoaded(true)
},100)

return()=>clearTimeout(timer)

},[location.pathname])

return(

<>

<section className={`services-section ${loaded?"loaded":""}`}>

<h2>
<LuBriefcase className="section-icon"/> Our Services
</h2>

<div className="services-grid">

<div className="services-card">
<LuTarget className="services-icon" style={{color:"#22c55e"}}/>
<h3>Career Direction</h3>
<p>
Students receive clear guidance about which skills and technologies to focus on based on their field.
</p>
</div>

<div className="services-card">
<LuMap className="services-icon" style={{color:"#8b5cf6"}}/>
<h3>Structured Roadmaps</h3>
<p>
Step-by-step learning paths showing what to study, which projects to build and how to progress.
</p>
</div>

<div className="services-card">
<LuTrendingUp className="services-icon" style={{color:"#f97316"}}/>
<h3>Placement Strategy</h3>
<p>
Insights about internships, skill expectations and preparation strategies for high paying jobs.
</p>
</div>

<div className="services-card">
<LuDatabase className="services-icon" style={{color:"#ef4444"}}/>
<h3>Real-Time Updates</h3>
<p>
Content is dynamically updated ensuring roadmaps stay relevant and industry aligned.
</p>
</div>

<div className="services-card">
<LuMessageSquare className="services-icon" style={{color:"#ec4899"}}/>
<h3>Doubt Support</h3>
<p>
Students can ask questions and receive support through communication features.
</p>
</div>

<div className="services-card">
<LuUsers className="services-icon" style={{color:"#6366f1"}}/>
<h3>Student Community</h3>
<p>
A collaborative learning ecosystem where students share ideas and progress.
</p>
</div>

<div className="services-card">
<LuShieldCheck className="services-icon" style={{color:"#14b8a6"}}/>
<h3>Secure Platform</h3>
<p>
All systems use secure authentication and protected databases for user safety.
</p>
</div>

<div className="services-card">
<LuRefreshCw className="services-icon" style={{color:"#3b82f6"}}/>
<h3>Continuous Improvement</h3>
<p>
The platform evolves constantly with updated industry insights and tools.
</p>
</div>

</div>

</section>

<OurConnections/>

</>

)

}

export default Services